import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import {
  IFeedAttributes,
  IFeedData,
  IFeedsPayload,
  IFeedsResponse,
  IFeedResponse
} from '@/interfaces/feeds'

const formatToRequest = (feed: IFeedAttributes): IFeedData => {
  return {
    name: feed.name,
    feed_format_id: feed.feed_format_id,
    stream: feed.stream,
    open_rtb: feed.open_rtb,
    url: feed.url,
    type_ids: feed.type_ids,
    qualities: feed.qualities,
    country_codes: feed.country_codes,
    feed_state: feed.feed_state,
    block_proxy_type_ids: feed.block_proxy_type_ids,
    device_ids: feed.device_ids,
    browser_ids: feed.browser_ids.map((browser) => Number(browser)),
    connection_type_ids: feed.connection_type_ids,
    no_bounces: feed.no_bounces,
    skip_if_no_ref: feed.skip_if_no_ref,
    skip_if_no_cookies: feed.skip_if_no_cookies,
    skip_if_x_requested_with: feed.skip_if_x_requested_with,
    no_onloop: feed.no_onloop,
    use_whitelist_domains: feed.use_whitelist_domains,
    whitelist_domains: feed.whitelist_domains,
    blacklist_domains: feed.blacklist_domains,
    use_whitelist_subids: feed.use_whitelist_subids,
    whitelist_subids: feed.whitelist_subids,
    blacklist_subids: feed.blacklist_subids,
    use_whitelist_user_agents: feed.use_whitelist_user_agents,
    whitelist_user_agents: feed.whitelist_user_agents,
    blacklist_user_agents: feed.blacklist_user_agents,
    included_spots: [],
    excluded_spots: [],
    platform_ids: feed.platform_ids.map((platform) => Number(platform)),
    refresh_rate: feed.refresh_rate,
    limits: feed.limits,
    size_ids: feed.size_ids,
    spot_ids: feed.spot_ids,
    spots_list_ids: feed.spots_list_ids,
    ron_type: feed.ron_type
  }
}

export const fetchItems = async (
  payload: IFeedsPayload
): Promise<IFeedsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter, true)
  )
  const response = await apiClient.get<IFeedsResponse>('/integrations', {
    params
  })
  return response.data
}

export const createItem = async (
  item: IFeedAttributes
): Promise<IFeedResponse> => {
  const response = await apiClient.post<IFeedResponse>(
    '/integrations',
    formatToRequest(item)
  )
  return response.data
}

export const updateItem = async (
  item: IFeedAttributes
): Promise<IFeedResponse> => {
  const response = await apiClient.put<IFeedResponse>(
    `/integrations/${item.id}`,
    formatToRequest(item)
  )
  return response.data
}

export const fetchItem = async (id: string): Promise<IFeedResponse> => {
  const response = await apiClient.get<IFeedResponse>(`/integrations/${id}`)
  return response.data
}

export const destroyItem = async (id: string): Promise<void> => {
  await apiClient.delete(`/integrations/${id}`)
}

export const updateItemState = async (
  id: string,
  event: string
): Promise<IFeedResponse> => {
  const response = await apiClient.post<IFeedResponse>(
    `/integrations/${id}/${event}`
  )
  return response.data
}

export const archiveItem = async (id: string): Promise<void> => {
  await apiClient.post(`/integrations/${id}/archive`)
}

export const massEnableItem = async (id: string): Promise<void> => {
  await apiClient.post(`/integrations/${id}/mass_enable`)
}
